import { oc } from '@orpc/contract';
import { addManualCostInputSchema, listCostItemsOutputSchema } from '../schemas/costs.schemas.js';
/**
 * A quoted amount with a reason. The category list deliberately has no `HOLDING` member: holding is
 * produced by the `holding` equation alone, so it is accounted exactly once (plan §3.3).
 */
export const addManualCostContract = oc
    .route({
    method: 'POST',
    path: '/costs/manual',
    tags: ['Costs'],
    summary: 'Record a manually quoted cost',
})
    .input(addManualCostInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=add-manual-cost.contract.js.map